import type { IntlShape } from "@formatjs/intl";
import { Button, Card, Flex, Typography } from "antd";
import {
  supplyCategoryColor,
  supplyCategoryMessageId,
} from "../../../common/utils/supplyCategories";
import type { SuppliesThisMonth } from "../../generated-axios-client";
import styles from "../Dashboard.module.css";

type Props = {
  intl: IntlShape;
  supplies: SuppliesThisMonth | undefined;
  loading: boolean;
  onOpenReport: () => void;
};

export const SuppliesThisMonthCard = ({
  intl,
  supplies,
  loading,
  onOpenReport,
}: Props) => {
  const topSupplies = supplies?.top_supplies ?? [];

  return (
    <Card
      className={styles.fullHeight}
      title={intl.formatMessage({ id: "dashboard_supplies_title" })}
      loading={loading}
      extra={
        <Button size="small" onClick={onOpenReport}>
          {intl.formatMessage({ id: "dashboard_supplies_open_report" })}
        </Button>
      }
    >
      {topSupplies.length === 0 ? (
        <Typography.Text type="secondary">
          {intl.formatMessage({ id: "dashboard_supplies_empty" })}
        </Typography.Text>
      ) : (
        <Flex vertical gap="small">
          <Typography.Text type="secondary">
            {intl.formatMessage(
              { id: "dashboard_supplies_summary" },
              { count: supplies?.work_order_count ?? 0 }
            )}
          </Typography.Text>
          {topSupplies.map((supply) => (
            <Flex
              key={`${supply.material_id}:${supply.measurement_unit_label}`}
              justify="space-between"
              align="center"
              gap="small"
              className={styles.supplyRow}
              style={{ borderInlineStartColor: supplyCategoryColor(supply.category) }}
            >
              <Flex vertical className={styles.supplyName}>
                <Typography.Text ellipsis={{ tooltip: supply.material_name }}>
                  {supply.material_name ?? "—"}
                </Typography.Text>
                <Typography.Text type="secondary">
                  {intl.formatMessage({ id: supplyCategoryMessageId(supply.category) })}
                </Typography.Text>
              </Flex>
              <Flex vertical align="end" className={styles.supplyAmount}>
                <Typography.Text strong>
                  {intl.formatNumber(Number(supply.total_amount))}
                  {supply.measurement_unit_label
                    ? ` ${supply.measurement_unit_label}`
                    : ""}
                </Typography.Text>
                <Typography.Text type="secondary">
                  {intl.formatMessage(
                    { id: "dashboard_supplies_work_orders" },
                    { count: supply.work_order_count }
                  )}
                </Typography.Text>
              </Flex>
            </Flex>
          ))}
        </Flex>
      )}
    </Card>
  );
};
